import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _SurveyType$INIT_SURV, _SurveyType$HORMONES_, _tw, _tw2, _cn, _cnhq;

import * as R from 'ramda';
import { ORG_TYPE, SurveyCategory, SurveyType } from 'src/types';
export var DIET_BRIEF_ANSWERS = {
  breakfast: {
    questionIDs: [3327, 4317]
  },
  lunch: {
    questionIDs: [3328, 4318]
  },
  dinner: {
    questionIDs: [3329, 4319]
  },
  snacksAndDrinks: {
    questionIDs: [3330, 4320]
  },
  dietType: {
    questionIDs: [3325, 4315]
  },
  dietPreference: {
    questionIDs: [3324, 4314]
  }
};
export var DIET_TARGET_ANSWERS = {
  bookingMotivation: {
    questionIDs: [3303, 4293]
  },
  mostToImproved: {
    questionIDs: [3345, 4335]
  }
};
export var VALID_SURVEY_MONTH_LIMIT = 6;
export var SURVEY_STATUS_CODES = {
  not_filled_out: 'not_filled_out',
  not_filled_out_child: 'not_filled_out_child',
  not_completed: 'not_completed',
  not_completed_child: 'not_completed_child',
  not_filled_out_basic_questionnaire: 'not_filled_out_basic_questionnaire',
  not_filled_out_basic_questionnaire_child: 'not_filled_out_basic_questionnaire_child',
  not_filled_out_hormone_questionnaire: 'not_filled_out_hormone_questionnaire',
  not_filled_out_hormone_questionnaire_child: 'not_filled_out_hormone_questionnaire_child',
  not_completed_basic_questionnaire: 'not_completed_basic_questionnaire',
  not_completed_basic_questionnaire_child: 'not_completed_basic_questionnaire_child',
  not_completed_hormone_questionnaire: 'not_completed_hormone_questionnaire',
  not_completed_hormone_questionnaire_child: 'not_completed_hormone_questionnaire_child',
  filled_out_completely: 'filled_out_completely'
};
export var SURVEY_STATUS_CODES_LIST = R.values(SURVEY_STATUS_CODES);
export var CategorySurvey = {
  tw: (_tw = {}, _defineProperty(_tw, SurveyType.INIT_SURVEY_ID, (_SurveyType$INIT_SURV = {}, _defineProperty(_SurveyType$INIT_SURV, SurveyCategory.ADULT, [31, 61, 67, 70, 86, 90, 121, 134]), _defineProperty(_SurveyType$INIT_SURV, SurveyCategory.CHILD, [136, 146, 148]), _SurveyType$INIT_SURV)), _defineProperty(_tw, SurveyType.HORMONES_SURVEY_ID, (_SurveyType$HORMONES_ = {}, _defineProperty(_SurveyType$HORMONES_, SurveyCategory.ADULT, [32, 62, 68, 71, 87, 93, 120]), _defineProperty(_SurveyType$HORMONES_, SurveyCategory.CHILD, [139, 147]), _SurveyType$HORMONES_)), _tw)
};
export var DefaultSurvey = {
  tw: (_tw2 = {}, _defineProperty(_tw2, SurveyType.INIT_SURVEY_ID, [].concat(_toConsumableArray(CategorySurvey.tw[SurveyType.INIT_SURVEY_ID][SurveyCategory.ADULT]), _toConsumableArray(CategorySurvey.tw[SurveyType.INIT_SURVEY_ID][SurveyCategory.CHILD]))), _defineProperty(_tw2, SurveyType.HORMONES_SURVEY_ID, [].concat(_toConsumableArray(CategorySurvey.tw[SurveyType.HORMONES_SURVEY_ID][SurveyCategory.ADULT]), _toConsumableArray(CategorySurvey.tw[SurveyType.HORMONES_SURVEY_ID][SurveyCategory.CHILD]))), _defineProperty(_tw2, SurveyType.SUPPLEMENT_SURVEY_ID, [85, 91]), _defineProperty(_tw2, SurveyType.W2_FEEDBACK_SURVEY_ID, [72, 73, 107, 118]), _defineProperty(_tw2, SurveyType.W5_FEEDBACK_SURVEY_ID, [81, 82, 108, 119, 145]), _defineProperty(_tw2, SurveyType.ADCT_SURVEY_ID, [102]), _defineProperty(_tw2, SurveyType.SUPPLEMENT_RETURN_SURVEY_ID, [101]), _defineProperty(_tw2, SurveyType.SUPPLEMENT_FEEDBACK_SURVEY_ID, [103]), _defineProperty(_tw2, SurveyType.ADVANCE_PLAN_SURVEY_ID, [106]), _defineProperty(_tw2, SurveyType.FOLLOW_UP_FEEDBACK_SURVEY_ID, [111]), _defineProperty(_tw2, SurveyType.ONE_ON_ONE_CONSULTING_SATISFACTION_SURVEY_ID, [114]), _defineProperty(_tw2, SurveyType.SUPPLEMENT_SATISFACTION_SURVEY_ID, [115]), _defineProperty(_tw2, SurveyType.SUPPLEMENT_FOLLOW_UP_SATISFACTION_SURVEY_ID, [113]), _defineProperty(_tw2, SurveyType.W8_FIRST_SURVEY_ID, [124]), _defineProperty(_tw2, SurveyType.W8_SUBSEQUENT_SURVEY_ID, [125]), _tw2),
  cn: (_cn = {}, _defineProperty(_cn, SurveyType.INIT_SURVEY_ID, [8, 14, 18]), _defineProperty(_cn, SurveyType.HORMONES_SURVEY_ID, [9, 15]), _cn),
  cnhq: (_cnhq = {}, _defineProperty(_cnhq, SurveyType.INIT_SURVEY_ID, [8, 14, 16, 17, 20, 21]), _defineProperty(_cnhq, SurveyType.HORMONES_SURVEY_ID, [9, 15, 22]), _cnhq)
};
export var SurveyTypesHaveTopicGuide = [SurveyType.INIT_SURVEY_ID];
export var getSurveyIdList = function getSurveyIdList(surveyType, orgType, category) {
  var region = process.env.NEXT_PUBLIC_ENVIRONMENT === 'china' ? orgType === ORG_TYPE.CONSULT ? 'cnhq' : 'cn' : 'tw';

  if (region === 'tw' && surveyType in CategorySurvey.tw && category) {
    return CategorySurvey.tw[surveyType][category];
  }

  return DefaultSurvey[region][surveyType] || [];
};
export var getSurveyTypeFromSurveyFormID = function getSurveyTypeFromSurveyFormID(surveyFormID, orgType) {
  var defaultSurvey = DefaultSurvey[process.env.NEXT_PUBLIC_ENVIRONMENT === 'china' ? orgType === ORG_TYPE.CONSULT ? 'cnhq' : 'cn' : 'tw'];

  var _ref = Object.entries(defaultSurvey).find(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        ids = _ref4[1];

    return ids.includes(surveyFormID);
  }) || [],
      _ref2 = _slicedToArray(_ref, 1),
      surveyType = _ref2[0];

  return surveyType;
};
export var isSurveyTypeFromSurveyFormID = function isSurveyTypeFromSurveyFormID(surveyFormID, surveyType, orgType) {
  var defaultSurvey = DefaultSurvey[process.env.NEXT_PUBLIC_ENVIRONMENT === 'china' ? orgType === ORG_TYPE.CONSULT ? 'cnhq' : 'cn' : 'tw'];
  var surveyFormIds = defaultSurvey[surveyType] || [];
  return surveyFormIds.includes(surveyFormID);
};